import React from "react";

import { Switch, SwitchProps } from "@progress/kendo-react-inputs";
import { useTranslation } from "react-i18next";

const YesNoSwitch: React.FC<SwitchProps> = (props: SwitchProps) => {
	const { t } = useTranslation();

	return <Switch {...props} offLabel={t("no")} onLabel={t("yes")} />;
};

export default YesNoSwitch;
